import React, { FC } from "react";

import { Text } from "@/components/Text";
import { IWorkOrder } from "@/data/work-orders";
import { Flex, IFlexProps } from "@/eworkitComponents";
import { BrandedLogo } from "@/views/components/Logo";

interface IWorkOrderSupplierProps extends Partial<IFlexProps> {
  workOrder: IWorkOrder;
}

export const WorkOrderSupplier: FC<IWorkOrderSupplierProps> = ({ workOrder, ...props }) => {
  return (
    <Flex innerMargin="md" align="center" {...props}>
      <BrandedLogo src={workOrder.origin.details.logo} />

      <Flex direction="column" innerMargin="xs">
        <Text size="xl">{workOrder.origin.name}</Text>
      </Flex>
    </Flex>
  );
};
